// extracted by mini-css-extract-plugin
module.exports = {"content":"Layout_content__BZybW","padded":"Layout_padded__ruUFc","topBorder":"Layout_topBorder__eJaeG","standalone":"Layout_standalone__rhULv","app":"Layout_app__hHZJD"};